export default __webpack_public_path__ + "static/media/SPACE-BUSD.20e858cf.png";